import React, { useState, MouseEvent } from 'react';
import * as AlertDialog from '@radix-ui/react-alert-dialog';
import { Images } from '@ansvar-sakerhet/ui/src/assets/images';
import { useDeleteControl } from '../../../../../../traits/api/controls/useDeleteControl';
import { S } from './RemoveControlDialog.styles';

type Props = {
  controlId: string;
  inspectionId: string;
  onClose: () => void;
};

export const RemoveControlDialog: React.FC<Props> = (props) => {
  const [confirmation, setConfirmation] = useState('');
  const [hasBeenDeleted, setHasBeenDeleted] = useState(false);

  const deleteControl = useDeleteControl({
    onDeleteControlSuccess: () => {
      setHasBeenDeleted(true);
    },
  });

  const canConfirm = confirmation.trim() === props.inspectionId;

  const onCancel = (
    e: MouseEvent<HTMLButtonElement, globalThis.MouseEvent>
  ) => {
    e.stopPropagation();
    setConfirmation('');
    setHasBeenDeleted(false);
    props.onClose();
  };

  return (
    <AlertDialog.Portal>
      <S.Overlay
        onClick={(e) => {
          e.stopPropagation();
        }}
        onMouseDown={(e) => {
          e.stopPropagation();
        }}
      >
        <S.Wrapper
          onClick={(e) => {
            e.stopPropagation();
          }}
          onMouseDown={(e) => {
            e.stopPropagation();
          }}
        >
          <S.CancelButton onClick={onCancel}>
            <S.Icon src="Close" width={24} height={24} />
          </S.CancelButton>

          {!hasBeenDeleted ? (
            <S.ContentContainer>
              <img src={Images.Delete} width={295} height={215} />

              <AlertDialog.Title asChild>
                <S.H5>Är du säker på att du vill ta bort kontrollen?</S.H5>
              </AlertDialog.Title>

              <AlertDialog.Description asChild>
                <S.H6>
                  Kontrollen och all tillhörande data raderas permanent och kan
                  inte återställas.
                </S.H6>
              </AlertDialog.Description>

              <S.Hint>
                Skriv kontrollnr <strong>{props.inspectionId}</strong> för att
                bekräfta.
              </S.Hint>

              <S.Input
                value={confirmation}
                onChange={(event) => setConfirmation(event.target.value)}
                onClick={(e) => e.stopPropagation()}
                placeholder="Kontrollnr"
                autoFocus
              />

              <S.ButtonContainer>
                <AlertDialog.Cancel asChild>
                  <S.Button $outlined onClick={onCancel}>
                    Avbryt
                  </S.Button>
                </AlertDialog.Cancel>

                <S.Button
                  disabled={!canConfirm || deleteControl.isLoading}
                  onClick={(e) => {
                    e.stopPropagation();
                    if (!canConfirm) return;
                    deleteControl.mutate({
                      controlId: props.controlId,
                      inspectionId: props.inspectionId,
                    });
                  }}
                >
                  Ja, ta bort
                </S.Button>
              </S.ButtonContainer>
            </S.ContentContainer>
          ) : (
            <S.ContentContainer>
              <img src={Images.Confirmation} width={276} height={225} />

              <AlertDialog.Title asChild>
                <S.H5>Kontrollen har raderats!</S.H5>
              </AlertDialog.Title>

              <S.ButtonContainer>
                <AlertDialog.Cancel asChild>
                  <S.Button onClick={onCancel}>Stäng</S.Button>
                </AlertDialog.Cancel>
              </S.ButtonContainer>
            </S.ContentContainer>
          )}
        </S.Wrapper>
      </S.Overlay>
    </AlertDialog.Portal>
  );
};
